import { NodeSettings } from '../../actionCard'

export class BaseNode<T = unknown> {
  data: T
  parent?: BaseNode
  children: Array<BaseNode> = []
  nodeSettings?: NodeSettings

  constructor(data: T, parent?: BaseNode, nodeSettings?: NodeSettings) {
    this.data = data
    this.parent = parent
    this.nodeSettings = nodeSettings
  }

  public getLabel(): string {
    const labelTemplate = this.getLabelTemplate()
    return this.nodeSettings?.actionCardModel?.replacementProcessor?.processReplacements(labelTemplate) || labelTemplate
  }

  public getId() {
    return (this.data as { id: number }).id
  }

  public getLabelTemplate(): string {
    return ''
  }

  /**
   * Returns the type of the node.
   * @returns The type of the node as a string, or undefined if not available.
   */
  public getType(): string | undefined {
    return (this.data as { type?: string }).type
  }
}
